import React, { useCallback } from 'react';
import ImageComponent from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { useAppDispatch } from '@kfc-global/react-shared/redux/Store/hooks';
import { setPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';

const { GoogleMapLocationImage } = IMAGE_PATH;

const UnitNumberComp = props => {
  const {
    show = false,
    suggestedAddress = '',
    confirmDeliveryAddressLineHandler,
    onChangeDeliveryAddressLine,
    deliveryAddressLineVal,
    shouldEnableConfirmButton,
    apartmentDetailsRegex,
  } = props;
  const { DELIVERY_ADDRESS_LINE_LABEL, CONFIRM_BTN_TEXT, PLEASE_FILL_OUT_THIS_FIELD } = TRANSLATE_MAPPING_KEY;
  const dispatch = useAppDispatch();
  /* called when unit number value is changed*/
  const setDeliveryAddressLineVal = useCallback(
    event => {
      if (apartmentDetailsRegex.test(event?.target?.value)) {
        onChangeDeliveryAddressLine(event.target.value);
        dispatch(setPWAstorage({ key: SEARCH_STORE_CONSTANTS?.SELECTED_LINE_ADDRESS_VAL, value: event.target.value }));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [onChangeDeliveryAddressLine],
  );
  return (
    <React.Fragment>
      {show ? (
        <div data-testid='delivery-address-line-container' className='err-container'>
          <div className='alert-location-popup unit-number-container'>
            <div className='icon-with-address'>
              <ImageComponent srcFile={GoogleMapLocationImage} alt=' ' className='google-location-img' />
              <span className='suggested-address-unit'>{suggestedAddress}</span>
            </div>
            <div className='unit-number-input-div'>
              <input
                data-testid='delivery-address-line-input'
                type='text'
                value={deliveryAddressLineVal}
                onChange={setDeliveryAddressLineVal}
                required
                title={translateWithI18Next(PLEASE_FILL_OUT_THIS_FIELD)}
              />
              <label>{translateWithI18Next(DELIVERY_ADDRESS_LINE_LABEL)}</label>
            </div>
          </div>
          <div className='text-center'>
            <ButtonComp
              className='button blackButton blackBorder delivery-confirm-button'
              data-testid='delivery-address-line-confirm'
              onClick={() => confirmDeliveryAddressLineHandler(deliveryAddressLineVal)}
              disabled={shouldEnableConfirmButton && !deliveryAddressLineVal?.length}
            >
              {translateWithI18Next(CONFIRM_BTN_TEXT)}
            </ButtonComp>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};
const UnitNumber = React.memo(UnitNumberComp);
export default UnitNumber;
